import Vue from 'vue';
export default class contactService {

    constructor(http, url, obj, callback) {
        this.http = http;
        this.url = url;
        this.obj = obj;
        this.callback = callback;
        this.request();
    }

    request() {
        this.http.post(this.url, this.obj).then( (response) => {
            if(response.ok) {
                if(typeof (this.callback === 'function')) {
                    return this.callback(response);
                }
            }
        },(response) => {
            this.disable = "none";
        });
    }
}



// WEBPACK FOOTER //
// ./src/domain/contactService.js